import React, { Suspense } from 'react';
import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import CartProvider from './components/cartProvider';
import Navbar from './components/navbar';
import { db } from './firebase';
import './App.css';
import WhatsappButton from './components/WhastAppButton';

import Footer from './components/footer';
import LoadingSpinner from './components/spinner';
import Spinner from './components/spinner';
import CreateUser from './components/createUser';

const Productos = React.lazy(() => import('./components/productos'));
const Revendedores = React.lazy(() => import('./components/Mayorista'));
const Cart = React.lazy(() => import('./components/cart'));
const About = React.lazy(() => import('./components/about'));
const Home = React.lazy(() => import('./components/home'));
const Contacto = React.lazy(() => import('./components/contacto'));
const ComoComprar = React.lazy(() => import('./components/howtobuy'));
const App = () => {
  const productosRef = db.collection('Productos');

  return (
    <div className="container-fluid p-0 m-0">
      <BrowserRouter>
        <CartProvider>
          <Navbar />
          <Suspense fallback={<Spinner/>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/productos" element={<Productos productosRef={productosRef} />} />
              <Route path="/revendedores" element={<Revendedores productosRef={productosRef} />} />
              <Route path="/about" element={<About />} />
              <Route path="/carrito" element={<Cart />} />
              <Route path="/spiner" element={<Spinner/>}/>
              <Route path="/contacto" element={<Contacto />}/>
              <Route path="/comocomprar" element={<ComoComprar />}/>
              <Route path="/createuser" element={<CreateUser/>}/>
            </Routes>
          </Suspense>
        
          <WhatsappButton />
          <Footer/>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
